import { Component } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Auth0Service } from '../../../authentication/auth0/auth0.service';
import { ShareDialogComponent } from "src/app/dashboards/share-dialog/share-dialog.component";
import {MatDialog} from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { PwaService } from '../../../shared/services/pwa.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: []
})
export class AppHeaderComponent {
  public config: PerfectScrollbarConfigInterface = {};
  imgUrl = environment.imgUrl;
  
  constructor(private auth: Auth0Service, 
    private dialog: MatDialog,
    public Pwa: PwaService) {}

  logout(){
    localStorage.clear();
    this.auth.logout();
  }
  // This is for socialSites
  socialSites: Object[] = [
    {
      icon: 'email',
      name: 'Email',
      onClick: () => this.openDialog("email address", "email")
    },
    {
      icon: 'message',
      name: 'Secure Text',
      onClick: () => this.openDialog("phone number", "phone")
    },
    {
      icon: 'print',
      name: 'Fax',
      onClick: () => this.openDialog("fax number", "fax")
    },
  ];

  openDialog(shareLabel : string, shareVia : string){
    const dialogRef = this.dialog.open(ShareDialogComponent, {
      width: '700px',
      data: {label: shareLabel, shareVia: shareVia}
    })
  }

  installPwa(): void {
    this.Pwa.promptEvent.prompt();
  }

}
